import { useCallback, useEffect, useMemo, useState } from 'react';

import { ItemTypes } from '@/src/modules/AutomationModuleNew/components/ActionRowMenu/ActionRowMenu';

import { useActionBar } from './useActionBar';

export const useHandleRowActions = <T,>() => {
  const [data, setData] = useState<T | undefined>(undefined);
  const {
    toggleEditModal,
    toggleDuplicateModal,
    toggleDeleteModal,
    editModalIsOpen,
    duplicateModalIsOpen,
    deleteModalIsOpen,
  } = useActionBar();

  const actionTypesMap = useMemo<{ [K in ItemTypes]: () => void }>(() => {
    return {
      edit: toggleEditModal,
      duplicate: toggleDuplicateModal,
      delete: toggleDeleteModal,
      move: () => {},
    };
  }, [toggleDeleteModal, toggleDuplicateModal, toggleEditModal]);

  const handleRowMenuClick = useCallback(
    (rowData: T) => (type: ItemTypes) => {
      setData(rowData);
      if (actionTypesMap[type]) {
        actionTypesMap[type]();
      }
    },
    [actionTypesMap]
  );

  useEffect(() => {
    if (!editModalIsOpen && !duplicateModalIsOpen && !deleteModalIsOpen) {
      setData(undefined);
    }
  }, [duplicateModalIsOpen, editModalIsOpen, deleteModalIsOpen]);

  return { data, handleRowMenuClick };
};
